module.exports = __webpack_public_path__ + "static/media/Teams.84b18107.svg";